import { Configuration, PublicClientApplication } from "@azure/msal-browser";

const config: Configuration = {
  auth: {
    authority:
      "https://login.microsoftonline.com/86cbe1bb-213f-4271-b174-bd59d03c87a3",
    clientId: "5a86d4f2-3b65-49f9-adbf-6c20ddb9283f",
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

// eslint-disable-next-line import/prefer-default-export
export const authProvider = new PublicClientApplication(config);
